module.exports = __webpack_public_path__ + "static/img/bgscimg5moxin1.ec54c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5moxin1.png
// module id = 1xts
// module chunks = 5